import script from "./ProyectoN2Empleo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProyectoN2Empleo.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__